import GatewayService from '../GatewayService.js';
var insights = new GatewayService('insights-service');
var apiRoot = 'api/insights';

var createInsights = function createInsights(newInsights) {
  return insights.post(apiRoot, newInsights);
};

var fetchInsight = function fetchInsight(insightKey) {
  return insights.get("".concat(apiRoot, "/").concat(insightKey));
};

var fetchAllInsights = function fetchAllInsights(classKey, includeArchived, since) {
  var params = {
    classKey: classKey,
    includeArchived: includeArchived,
    since: since
  };
  return insights.get(apiRoot, {
    params: params
  });
};

var updateInsight = function updateInsight(insightKey, updatedInsight) {
  return insights.put("".concat(apiRoot, "/").concat(insightKey), updatedInsight);
};

var updateInsightStudent = function updateInsightStudent(insightKey, studentKey, updatedStudent) {
  return insights.put("".concat(apiRoot, "/").concat(insightKey, "/students/").concat(studentKey), updatedStudent);
};

export default {
  createInsights: createInsights,
  fetchInsight: fetchInsight,
  fetchAllInsights: fetchAllInsights,
  updateInsight: updateInsight,
  updateInsightStudent: updateInsightStudent
};